export var LedgerReportOperationsEnum;
(function (LedgerReportOperationsEnum) {
    LedgerReportOperationsEnum["DOWNLOADSTATUS"] = "downloadStatus";
    LedgerReportOperationsEnum["EMAILSTATUS"] = "emailStatus";
})(LedgerReportOperationsEnum || (LedgerReportOperationsEnum = {}));
